import * as React from "react";

import {
  formatMoney,
  redirectFileLocalUrl,
} from "shared/plugins/string-helper";
import { useAppDispatch } from "app.hook";
import {
  closeConfirmModal,
  showConfirmModal,
} from "states/global-value/global-value.slice";
import { ConfirmModel } from "states/global-value/global-value.models";
import { ShoppingCartItem } from "states/shopping-cart/shopping-cart.models";
import {
  calculateTotal,
  removeItemShoppingCart,
  updateQuantityItemShoppingCart,
} from "states/shopping-cart/shopping-cart.slice";
import { nanoid } from "@reduxjs/toolkit";
import { IconMinus, IconPlus, IconTrash } from "themes";
export interface IButtonModalViewCartProps {
  item: ShoppingCartItem;
  index: number;
}

export function ItemModalViewCart({ item, index }: IButtonModalViewCartProps) {
  const dispatch = useAppDispatch();
  const handleRemove = () => {
    dispatch(removeItemShoppingCart(index));
    dispatch(closeConfirmModal());
  };

  const handleUpdateQuantity = (quantity: number) => {
    dispatch(updateQuantityItemShoppingCart({ index, quantity }));
  };

  return (
    <div className="desktop-cart-item">
      <div className="item-image-wrapper">
        {item.image !== "" && item.image !== null ? (
          <img
            className="item-image"
            src={redirectFileLocalUrl(item.image)}
            alt={item.name}
          />
        ) : (
          <div className="avatar-thumb bg-yellow-50" />
        )}
      </div>

      <div className="item-details">
        <div className="item-name">{item?.name}</div>
        <div className="item-price">{formatMoney(item.price, 2, ".", ",", "$")}</div>
        {item?.modifiers?.length > 0 && (
          <div className="item-modifiers">
            {item?.modifiers?.map((modi) => (
              <span className="modifier-badge" key={nanoid()}>
                {modi.name} (+{formatMoney(modi.price * modi.quantity, 2, ".", ",", "$")}) Qty: {modi.quantity}
              </span>
            ))}
          </div>
        )}
      </div>

      <div className="quantity-controls">
        <button
          onClick={() => {
            if (item.quantity === 1) {
              return;
            }
            handleUpdateQuantity(item.quantity - 1);
          }}
          className="qty-btn"
        >
          <IconMinus width={18} />
        </button>
        <span className="qty-display">{item.quantity}</span>
        <button
          onClick={() => {
            handleUpdateQuantity(item.quantity + 1);
          }}
          className="qty-btn"
        >
          <IconPlus width={18} />
        </button>
      </div>

      <div className="item-subtotal">
        {formatMoney(calculateTotal(item), 2, ".", ",", "$")}
      </div>

      <button
        onClick={() => {
          dispatch(
            showConfirmModal({
              title: "Warning",
              message: "Are you sure you want to delete this item?",
              onYes: () => {
                handleRemove();
              },
            } as ConfirmModel)
          );
        }}
        className="delete-btn"
      >
        <IconTrash width={20} />
      </button>
    </div>
  );
}
